import { create } from "zustand";
import { DEFAULT_MODEL } from "@/core/ai";

const STORAGE_KEY = "hippo.ai";

interface Persisted {
  enabled: boolean;
  apiKey: string;
  model: string;
}

function load(): Persisted {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const p = JSON.parse(raw) as Partial<Persisted>;
      return {
        enabled: p.enabled ?? false,
        apiKey: p.apiKey ?? "",
        model: p.model ?? DEFAULT_MODEL,
      };
    }
  } catch {
    /* ignore */
  }
  return { enabled: false, apiKey: "", model: DEFAULT_MODEL };
}

interface AIState extends Persisted {
  setEnabled: (v: boolean) => void;
  setApiKey: (v: string) => void;
  setModel: (v: string) => void;
  /** Feedback can run: enabled, with a key set. */
  isConfigured: () => boolean;
}

export const useAIStore = create<AIState>((set, get) => {
  const persist = () => {
    const { enabled, apiKey, model } = get();
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ enabled, apiKey, model }));
  };
  return {
    ...load(),
    setEnabled: (enabled) => {
      set({ enabled });
      persist();
    },
    setApiKey: (apiKey) => {
      set({ apiKey });
      persist();
    },
    setModel: (model) => {
      set({ model });
      persist();
    },
    isConfigured: () => {
      const { enabled, apiKey } = get();
      return enabled && apiKey.trim().length > 0;
    },
  };
});
